<template>
	<nav class="main-header navbar navbar-expand navbar-white navbar-light">
		<!-- Left navbar links -->
		<ul class="navbar-nav">
			<li class="nav-item">
				<a class="nav-link" data-widget="pushmenu" href="#" role="button">
					<i class="fas fa-bars"></i>
				</a>
			</li>
		</ul>
		<!-- Right navbar links -->
		<ul class="navbar-nav ml-auto">
			<li class="nav-item" title="Xem toàn màn hình">
				<a class="nav-link" data-widget="fullscreen" href="#" role="button">
					<i class="fas fa-expand-arrows-alt"></i>
				</a>
			</li>
			<li class="nav-item dropdown" title="Thông tin cá nhân">
				<a class="nav-link" data-toggle="dropdown" href="#">
					<i class="fas fa-user"></i>
				</a>
				<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
					<span class="dropdown-item dropdown-header text-primary"><i class="fas fa-user-cog mr-1"></i>{{ hoTen }}</span>
					<div class="dropdown-divider"></div>
					<router-link to="/changepassword" class="dropdown-item">
						<i class="fas fa-key mr-2"></i> {{ $t('labels.changePassword') }}
					</router-link>
					<div class="dropdown-divider"></div>
					<router-link to="/changepersonalinfo" class="dropdown-item">
						<i class="fas fa-info-circle mr-2"></i> {{ $t('labels.changeInfo') }}
					</router-link>
					<div class="dropdown-divider"></div>
					<router-link to="/logout" class="dropdown-item">
						<i class="fas fa-sign-out-alt mr-2"></i> {{ $t('labels.logout') }}
					</router-link>
				</div>
			</li>
		</ul>
	</nav>
</template>

<script>
	export default {
		name: 'TheNavBar',
		data() {
			return {
				hoTen: null
			}
		},
		mounted() {
			this.hoTen = JSON.parse(localStorage.getItem('user')).userInfo.hoTen;
		},
	}
</script>